var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrap"},[_vm._l((Object.values(_vm.data)),function(item){return [_c('SensorChart',_vm._b({key:item.name,attrs:{"color":_vm.color}},'SensorChart',item,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }